import styled from 'styled-components'

/**
 * A stylised stand-in for the report's cover page. It is deliberately
 * abstract rather than a render of the real PDF — rendering page one would
 * mean pulling in a PDF library — so it is decorative and hidden from
 * assistive tech.
 */
export const ReportThumbnail = styled.div`
  flex: 0 0 auto;
  /* Sized so the page's height lands close to the heading + date + buttons
     column beside it, rather than overhanging the bottom of the card. */
  width: 88px;
  aspect-ratio: 8.5 / 11;
  box-sizing: border-box;
  padding: 9px 7px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: hidden;
  background-color: rgb(var(--m-color-neutral-0));
  border: 1px solid rgb(var(--m-color-neutral-40));
  border-radius: var(--m-border-radius-s);
  box-shadow: var(--m-elevation-1);
`

export const ThumbnailBar = styled.span`
  height: 4px;
  width: 46%;
  border-radius: 2px;
  background-color: rgb(var(--m-color-primary-60));
`

export const ThumbnailLine = styled.span<{ $width: string }>`
  height: 2.5px;
  width: ${({ $width }) => $width};
  border-radius: 2px;
  background-color: rgb(var(--m-color-neutral-20));
`

export const ThumbnailChart = styled.span`
  margin-top: 4px;
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 30px;
`

export const ThumbnailColumn = styled.span<{ $height: string }>`
  flex: 1;
  height: ${({ $height }) => $height};
  border-radius: 1px 1px 0 0;
  background-color: rgb(var(--m-color-primary-20));
`

/**
 * Miranda's Button has no icon-only mode, so an icon button keeps the full
 * 16px text padding on each side and the row reads as three widely spaced
 * controls. Tighten the padding on the icon buttons and sit them close
 * together, so they group as one set of actions.
 */
export const RowActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--m-spacing-1);

  m-button {
    --m-button-padding-x: var(--m-spacing-2);
  }
`

/**
 * The dialog renders the PDF at full-page size; the iframe should take all
 * the room the dialog body gives it.
 */
export const PreviewFrame = styled.iframe`
  width: 100%;
  height: 72vh;
  border: none;
  display: block;
`
